import { RegionGroup } from "lib/types/leaderboards";

export const regionText = {
  france: "France",
  uk: "UK & Ireland",
  nordics: "Nordics",
  germany: "Germany",
  central: "Central Europe",
  southern: "Southern Europe",
  eastern: "Eastern Europe & Baltics",
  benelux: "Benelux",
  europe: "Europe",
};

export const regionGroups: Record<string, RegionGroup> = {
  europe: { label: "Europe", regions: ["europe"] },
  uk: { label: "UK & Ireland", regions: ["uk"] },
  franceAndSouthern: {
    label: "France & Southern Europe",
    regions: ["france", "southern"],
  },
  dachAndCee: {
    label: "DACH & CEE",
    regions: ["germany", "central", "eastern"],
  },
  nordics: { label: "Nordics & Benelux", regions: ["nordics", "benelux"] },
};
